const villa_sec1_part1Object = (payload) => {
  return {
    type: "villasec1part1",
    payload,
  };
};

export default villa_sec1_part1Object;
